<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto top-navbar-container">
      <li class="nav-item b-nav-dropdown user-balance">
        <p class="font-weight-bolder mb-0">
          <span
            v-if="typeof userData !== 'undefined'"
            v-text="$t('own_balance')"
          />:
          <span
            v-if="typeof userData !== 'undefined'"
            style="margin-right: 10px;"
            v-text="new Intl.NumberFormat('fil-PH', { minimumFractionDigits: 2 }).format(Number(userData.balance))"
          />
        </p>
      </li>
      <locale />
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              <span
                v-if="typeof userData !== 'undefined'"
                v-text="userData.username"
              />
            </p>
            <span
              v-if="typeof userData !== 'undefined'"
              class="user-status"
              v-text="userData.role"
            />
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/default.jpg')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click.prevent="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span v-text="$t('logout')" />
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BAvatar,
} from 'bootstrap-vue'
import Locale from '@/layouts/components/nav-bar/Locale.vue'
import DarkToggler from '@/layouts/components/nav-bar/DarkToggler.vue'
import useJwt from '@/auth/jwt/useJwt'
import { initialAbility } from '@/libs/acl/config'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Account from '@/models/Account'

import { EventBus } from '../../../eventbus'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BAvatar,

    // Navbar Components
    Locale,
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      userData: {
        balance: 0,
        share: 0,
        commission: 0,
      },
    }
  },
  mounted() {
    EventBus.$on('getMyUpdatedUserData', this.getMyUserData)
  },
  methods: {
    async getMyUserData() {
      const response = await Account.me()
      this.userData = response.data
    },
    async logout() {
      try {
        await useJwt.logout()
        useJwt.removeTokens()

        this.$ability.update(initialAbility) // Reset ability

        await this.$router.replace({ name: 'login' })
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: e.message,
          },
        })
      }
    },
  },
}
</script>
